module.exports = __webpack_public_path__ + "static/ey-8-d9c1b829d87202f67511d0e1d9ab9afd.png";